import "./jobmatch.scss";
import React, { useState, useEffect } from "react";
import { JobCard } from "components/jobseeker/jobmatch/jobcard";
import { JobLists } from "components/jobseeker/jobmatch/joblists";
import { useDispatch, useSelector } from "react-redux";
import * as JobActions from "redux/actions/JobActions";
import storage from "utils/storage";
import { FormattedMessage } from "react-intl";
import { useHistory } from "react-router-dom";
import * as UserActions from "redux/actions/UserActions";
import * as JobCategoryActions from "redux/actions/jobcategory";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Button, Form, Col } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { DistrictList } from "components/jobseeker/DistrictList";
import { common, educationalQualificationList, errorMessage, experienceList, genderList, jobDetails, jobPostTimeList, jobShiftList, jobTypeList } from "config/app.constant";
import { FaTimes } from "react-icons/fa";
import Multiselect from "multiselect-react-dropdown";
import { ProfileDetails } from "components/jobseeker/profileDetails/profileDetails";


export const JobView = () => {
  const { register, handleSubmit } = useForm({
    mode: "onBlur",
  });
  const history = useHistory();
  const dispatch = useDispatch();
  const sortedDistrictList = DistrictList.sort();
  const [loaded, setLoaded] = useState(false);
  const { jobList } = useSelector((state) => state.jobReducer);
  const [jobFilterModal, setJobFilterModal] = useState(false);
  const [searchModal, setSearchModal] = useState(false);
  const [selectedDistrictList, setSelectedDistrictList] = useState([]);
  const [filterJobs, setFilterJobs] = useState();
  const [userCategory, setUserCategory] = useState([]); // Aray of categories present in user details
  const [allCategories, setAllCategories] = useState([{}]); // All categories from store
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [filterCategories, setFilterCategories] = useState([]);
  const [skills, setSkills] = useState([''])
  const [selectedSkills, setSelectedSkills] = useState([''])
  const { userDetails } = useSelector((state) => state.userReducer);
  const [message, setMessage] = useState()
  const userId = storage.get("humlog_user");

  // Handle Open Jobs filter Modal
  const openJobFilter = (userDetails) => {
    setJobFilterModal(true); // close Job filter modal
    categoryList(userDetails.job_intrested); // setting categories of user
    fetchAllCategories(); // Fetch all categories with Id
    fetchUserCategory(); // Fetch user categories with Id
  };
  // Handle close Jobs filter Modal
  const closeJobFilter = () => {
    setJobFilterModal(false);
  };

  // Handle Open search filter Modal
  const openSearch = () => {
    setSearchModal(true)
    setTimeout(() => {
      closeSearch()
    }, 2000);
  };
  // Handle close search filter Modal
  const closeSearch = () => {
    setSearchModal(false)
  };

  // Handle multi selected District Value in Jobs filter Modal
  const onChangeDistrict = (list) => {
    setSelectedDistrictList(list);
  };

  // Handle multi selected Category Value in Jobs filter Modal
  const onChangeCategory = (list) => {
    let categoryId = list.map((item) => {
      return item._id;
    });
    setSelectedCategory(categoryId);
  };

  // Handle multi selected Skills Value in Jobs filter Modal
  const onChangeSkills = (list) => {
    setSelectedSkills(list);
  };

  // Handle submission of Jobs filter values
  const submitFilterJobs = (val) => {
    val["district"] = selectedDistrictList; // sending selected districts value
    val["category"] = selectedCategory; // sending selected categories value
    val["skills"] = selectedSkills; // sending selected Skills value
    dispatch(JobActions.getJobFilterListData(val))
      .then((res) => {
        if (res.value.success) {
          setFilterJobs(res.value.data);
          if (res.value.count === 0) {
            setMessage(errorMessage.NO_RECORD)
          }
          setSelectedCategory([]); // reset value of category to empty string
          setSelectedDistrictList([]); // reset value of district to empty string
          setSelectedSkills([]); // reset value of skills to empty string
          history.push({ path: "/jobs", state: { isFiltered: true } });
          if (res.value.count === 0) {
            openSearch()
          }
        }
        closeJobFilter();
      })
      .catch((err) => console.log(err.message));
  };
  // Function to fetch user category names detail
  const categoryList = () => {
    const categoryArray = userDetails.job_intrested;
    let categoryNames = categoryArray.map((item) => {
      return item.job_category;
    });
    setUserCategory(categoryNames); // storing user category names
  };

  // Function to fetch all category list
  const fetchAllCategories = () => {
    dispatch(JobCategoryActions.getJobCategoryListData())
      .then((res) => {
        if (res.value.success) {
          setAllCategories(res.value.data);
        }
      })
      .catch((err) => console.log("err", err.message));
  };

  // Function to Fetch users category with _id from List of all categories
  const fetchUserCategory = () => {
    let skills = []
    allCategories.forEach((obj) => {
      if (userCategory.indexOf(obj.name) !== -1) obj["contains"] = true; // seprate user categories from List of all categories by adding key ["contains"] = true
    });
    let category;
    let filteredCategory = allCategories.filter((item) => {
      if (item.contains) {
        category = { name: item.name, _id: item._id, skills: item.skills }; // Filter user categories from All categories List
        return category;
      }
    }).map((item) => {
      category = { name: item.name, _id: item._id, skills: item.skills }; // mapping required feilds
      skills.push(...item.skills) // Feteching skills of categories of user 
      return category;
    });
    setFilterCategories(filteredCategory); // Storing filtered categories 
    setSkills(skills) // Storing list of skills of user categories
  };
  useEffect(() => {
    if (!loaded) {
      setLoaded(true);
      dispatch(JobActions.getJobListData(storage.get("humlog_user")));
      dispatch(UserActions.getUserData(userId));
    }
  }, [loaded, userId, dispatch]);
  return (
    <>
      <div className="row">
        <div className="col-md-3">
          <ProfileDetails />
        </div>
        <div className="col-md-9">
          <div className="joblistview">
            <h5 className="page_title pt-3 pl-3">
              <FormattedMessage id="viewJobs" defaultMessage="View Jobs" />
            </h5>
            {jobList && jobList.length === 0 ? (
              ""
            ) : (
              <div className="joblistheader">
                <img
                  onClick={() => openJobFilter(userDetails)}
                  className="job_filter_icon"
                  src='/images/dashboard/job_filter_Icon.svg'
                />
              </div>
            )}
            <JobLists
              jobList={filterJobs && filterJobs.length ? filterJobs : jobList}
            />
          </div>
        </div>
      </div>

      {/*---------- Job filter modal-section start from here ----------*/}
      <Dialog open={jobFilterModal} onClose={closeJobFilter}>
        <DialogTitle className="page_title text-center">
          <p className="modal-title h4">
            {"Filters"}
          </p>
        </DialogTitle>
            
        <button className="modal_close_btn" onClick={closeJobFilter}>
          <FaTimes />
        </button>
        <DialogContent>
          <DialogContentText>
            <Form
              onSubmit={handleSubmit(submitFilterJobs)}
              className="jobPostForm"
            >
              <div>
                {/* ------ district-section start from here ------ */}
                <Form.Group controlId="district">
                  <Form.Label className="d-flex justify-content-start job_filter_title">
                    <FormattedMessage
                      id="jobLocation"
                      defaultMessage={common.JOB_LOCATION}
                    />
                  </Form.Label>
                  <Multiselect
                    id="district"
                    options={sortedDistrictList}
                    isObject={false}
                    selectionLimit={3}
                    onSelect={onChangeDistrict}
                    onRemove={onChangeDistrict}
                    placeholder={common.SELECT_DISTRICT}
                  />
                </Form.Group>
                {/* ------ district-section end ------ */}

                {/* ------ Salary-section start ------ */}
                <Form.Group controlId="salary">
                  <Form.Label className="d-flex justify-content-start job_filter_title">
                    <FormattedMessage
                      id="jobSalaryRange"
                      defaultMessage={common.SALARY_RANGE}
                    />
                  </Form.Label>
                  <Form.Row>
                    <Col>
                      <Form.Control
                        placeholder={common.EG_7000}
                        name="salary_from"
                        autocomplete="off"
                        className="form-control"
                        type="number"
                        min={7000}
                        max={50000}
                        ref={register()}
                      />
                    </Col>
                    <FormattedMessage id="to" defaultMessage="to" />
                    <Col>
                      <Form.Control
                        placeholder={common.EG_50000}
                        type="number"
                        min={7000}
                        max={50000}
                        name="salary_to"
                        autocomplete="off"
                        className="form-control"
                        ref={register()}
                      />
                    </Col>
                  </Form.Row>
                </Form.Group>
                {/* ------ Salary-section end ------ */}

                {/* ------ Educational Qualification section start ------ */}
                <Form.Group controlId="educational_qualification">
                  <Form.Label className="d-flex justify-content-start job_filter_title">
                    <FormattedMessage
                      id="educationalQualification"
                      defaultMessage={jobDetails.EDU_QUALIFICATION}
                    />
                  </Form.Label>
                  <Form.Control
                    as="select"
                    autocomplete="off"
                    name="educational_qualification"
                    ref={register()}
                  >
                    {educationalQualificationList.map((item) => (
                      <option value={item.value}>{item.name}</option>
                    ))}
                  </Form.Control>
                </Form.Group>
                {/* ------ Educational Qualification  section end ------ */}

                {/* ------ Gender preference section start ------ */}
                <Form.Group controlId="gender">
                  <Form.Label className="d-flex justify-content-start job_filter_title">
                    <FormattedMessage
                      id="gender"
                      defaultMessage={common.GENDER}
                    />
                  </Form.Label>
                  <Form.Control
                    as="select"
                    autocomplete="off"
                    name="gender"
                    ref={register()}
                  >
                    {genderList.map((item) => (
                      <option value={item.value}>{item.name}</option>
                    ))}
                  </Form.Control>
                </Form.Group>
                {/* ------ Gender preference section end ------ */}

                {/* ------ Work Experience section start ------ */}
                <Form.Group controlId="experience">
                  <Form.Label className="d-flex justify-content-start job_filter_title">
                    <FormattedMessage
                      id="experienceRequired"
                      defaultMessage={common.EXP_REQUIRED}
                    />
                  </Form.Label>
                  <Form.Control
                    as="select"
                    autocomplete="off"
                    name="experience"
                    ref={register()}
                  >
                    {experienceList.map((item) => (
                      <option value={item.value}>{item.name}</option>
                    ))}
                  </Form.Control>
                </Form.Group>
                {/* ------ Work Experience section end ------ */}

                {/* ------ Job-category section start ------ */}
                <Form.Group controlId="job-category">
                  <Form.Label className="d-flex justify-content-start job_filter_title">
                    <FormattedMessage
                      id="jobCategory"
                      defaultMessage={common.JOB_CATEGORY}
                    />
                  </Form.Label>
                  <Multiselect
                    id="jobCategory"
                    options={filterCategories}
                    isObject={true}
                    selectionLimit={3}
                    displayValue="name"
                    onSelect={onChangeCategory}
                    onRemove={onChangeCategory}
                    placeholder={common.SELECT_CATEGORY}
                  />
                </Form.Group>
                {/* ------ Job-category section end ------ */}

                {/* ------ Skills section start ------ */}
                <Form.Group controlId="skills">
                  <Form.Label className="d-flex justify-content-start job_filter_title">
                    <FormattedMessage id="skills" defaultMessage={common.SKILLS} />
                  </Form.Label>
                  <Multiselect
                    id="skills"
                    options={skills}
                    isObject={false}
                    selectionLimit={3}
                    onSelect={onChangeSkills}
                    onRemove={onChangeSkills}
                    placeholder={common.SELECT_SKILLS}
                  />
                </Form.Group>
                {/* ------ Skills section end ------ */}

                {/* ------ Job Type section start ------ */}
                <Form.Group controlId="job_type">
                  <Form.Label className="d-flex justify-content-start job_filter_title">
                    <FormattedMessage id="jobType" defaultMessage={common.JOB_TYPE} />
                  </Form.Label>
                  <Form.Control
                    as="select"
                    autocomplete="off"
                    name="job_type"
                    ref={register()}
                  >
                    {jobTypeList.map((item) => (
                      <option value={item.value}>{item.name}</option>
                    ))}
                  </Form.Control>
                </Form.Group>
                {/* ------ Job Type section end ------ */}

                {/* ------ Job Shift section start ------ */}
                <Form.Group controlId="job_timings">
                  <Form.Label className="d-flex justify-content-start job_filter_title">
                    <FormattedMessage
                      id="jobShift"
                      defaultMessage={common.JOB_SHIFT}
                    />
                  </Form.Label>
                  <Form.Control
                    as="select"
                    autocomplete="off"
                    name="job_timings"
                    ref={register()}
                  >
                    {jobShiftList.map((item) => (
                      <option value={item.value}>{item.name}</option>
                    ))}
                  </Form.Control>
                </Form.Group>
                {/* ------ Job Shift section end ------ */}

                {/* ------ Job Posted Time section start ------ */}
                <Form.Group controlId="job_posted_time">
                  <Form.Label className="d-flex justify-content-start job_filter_title">
                    <FormattedMessage
                      id="jobPostTime"
                      defaultMessage={common.JOB_POST_TIME}
                    />
                  </Form.Label>
                  <Form.Control
                    as="select"
                    autocomplete="off"
                    name="job_posted_time"
                    ref={register()}
                  >
                    {jobPostTimeList.map((item) => (
                      <option value={item.value}>{item.name}</option>
                    ))}
                  </Form.Control>
                </Form.Group>
                {/* ------ Job Posted Time end ------ */}

                <div className="text-center">
                  <Button type="sumit">{common.APPLY_FILTERS}</Button>
                </div>
              </div>
            </Form>
          </DialogContentText>
        </DialogContent>
      </Dialog>
      {/* ---------- Job filter modal end ----------*/}


      {/*---------- Search filter modal-section start from here ----------*/}
      <Dialog open={searchModal} onClose={closeSearch}>
        <DialogTitle className="page_title">{message}</DialogTitle>
        <button className="modal_close_btn" onClick={closeSearch}>
          <FaTimes />
        </button>
        {/* <DialogContent>
        <DialogContent>
          <DialogContentText>
            {message}
          </DialogContentText>
        </DialogContent>
      </DialogContent> */}
      </Dialog>
      {/* ---------- Search filter modal-section modal end ----------*/}
    </>
  )
}